/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InvitationSummary } from './InvitationSummary';
import {
    InvitationSummaryFromJSON,
    InvitationSummaryFromJSONTyped,
    InvitationSummaryToJSON,
    InvitationSummaryToJSONTyped,
} from './InvitationSummary';

/**
 * Result of an invitation action (resend, cancel)
 * @export
 * @interface InvitationActionResponse
 */
export interface InvitationActionResponse {
    /**
     * 
     * @type {boolean}
     * @memberof InvitationActionResponse
     */
    success: boolean;
    /**
     * 
     * @type {InvitationSummary}
     * @memberof InvitationActionResponse
     */
    invitation: InvitationSummary;
}

/**
 * Check if a given object implements the InvitationActionResponse interface.
 */
export function instanceOfInvitationActionResponse(value: object): value is InvitationActionResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('invitation' in value) || value['invitation'] === undefined) return false;
    return true;
}

export function InvitationActionResponseFromJSON(json: any): InvitationActionResponse {
    return InvitationActionResponseFromJSONTyped(json, false);
}

export function InvitationActionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvitationActionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'invitation': InvitationSummaryFromJSON(json['invitation']),
    };
}

export function InvitationActionResponseToJSON(json: any): InvitationActionResponse {
    return InvitationActionResponseToJSONTyped(json, false);
}

export function InvitationActionResponseToJSONTyped(value?: InvitationActionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'invitation': InvitationSummaryToJSON(value['invitation']),
    };
}

